import { Grid, Typography, Button } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { ScheduleSend } from "@mui/icons-material";

import constants from "../../../../../utils/constants";
import GoogleRecaptcha from "../../../../UI/GoogleRecaptcha";

export default function ClientDetailsActions(props) {
  const { loading, validInfo, onInfoDialogOpen, meetingType } = props;

  return (
    <Grid container justifyContent="space-between" alignItems="center" rowSpacing={1} pt={0}>
      <Grid item>
        <Typography variant="caption" display="block">
          * Required fields
        </Typography>
        {onInfoDialogOpen && (
          <Button size="small" onClick={onInfoDialogOpen}>
            Why do we ask for this info?
          </Button>
        )}
      </Grid>

      <Grid item>
        <Grid container justifyContent={"center"} rowSpacing={1}>
          <Grid item>
            <GoogleRecaptcha />
          </Grid>

          <Grid item>
            <LoadingButton
              variant="contained"
              loading={loading}
              loadingPosition="start"
              startIcon={<ScheduleSend />}
              disabled={!validInfo}
              type="submit"
              sx={{ height: "100%" }}
            >
              {meetingType === constants.MEETING_TYPES.PHONE ? "Book Call" : "Book Meeting"}
            </LoadingButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
